<template>
<div>
    <base-header v-once pageName="FAQ" :prevBtnShow="true" history="main"></base-header>

    <section id="wrap">
        <div class="faq">
            <p>전체 <em>{{tot}}</em>건</p>
            <div>
                <button type="button" :class="{ current : divCd == 'CFD00'}" @click="activeTab('CFD00')">전체</button>
                <button type="button" :class="{ current : divCd == 'CFD01'}" @click="activeTab('CFD01')">APP(앱)</button>
                <button type="button" :class="{ current : divCd == 'CFD02'}" @click="activeTab('CFD02')">인사</button>
                <button type="button" :class="{ current : divCd == 'CFD03'}" @click="activeTab('CFD03')">제도</button>
                <button type="button" :class="{ current : divCd == 'CFD04'}" @click="activeTab('CFD04')">교육</button>
                <button type="button" :class="{ current : divCd == 'CFD05'}" @click="activeTab('CFD05')">서비스</button>
            </div>

            <ul>
                <li v-for="item in list" v-bind:key="item.sqno">
                    <p class="qus" @click="openAnswer(item.sqno)" :class="item.sqno === active ? 'open' : null ">{{htmlParser(item.titl)}}</p>
                    <div class="ans" v-html="htmlParser(item.cntn)">
                    </div>
                </li>
            </ul>
        </div>

        <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
        <div slot="no-more"></div>
        <div slot="no-results">검색된 정보가 없습니다.</div>
      </infinite-loading>
      <!-- 2026.09.18 챗봇 버튼-->
      <div class="fltMn">
          <button type="button" class="chatbot allow-click" @click="chatbot"></button>
      </div>
      <!--// 2026.09.18 챗봇 버튼-->
    </section>
</div>
</template>

<script>
var parser = new DOMParser();
import InfiniteLoading from "vue-infinite-loading";

export default {
  name: "FaqList",
  components: {
    InfiniteLoading,
    // FaqList
  },
  data() {
      return{
          loginGbn : this.$store.getters.loginGbn, //로그인구분
          sqno : 0,
          active : null,
          list:[],
          tot:0,
          offset: 0,     //현재 가지고있는 갯수
          size : 10,    //한번에 가져오는 수
          divCd: 'CFD00'
      };
  },

  methods: {
    infiniteHandler : function($state){
			console.log('SCROLL')
      var that = this;
      var parameters = {
        offset: this.offset,
        size: this.size,
        divCd : this.divCd
      };
      this.$api.faq
        .list(parameters)
        .then(function(data) {
          that.tot = data.totCnt;  // API에서 가져온 총 카운트
          var list = data.list;   //API에서 가져온 리스트
          if (list.length) {
            that.list = that.list.concat(list);
            $state.loaded();
            that.offset += that.size;

            if (list.length < that.size) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
          console.log(error);
        });
    },

    openAnswer:function (index) {
        if(this.active==index) this.active=null;
        else this.active=index
    },
     activeTab: function(selectDivCd) {
        this.active = null
        this.divCd = selectDivCd
        this.totalCnt = 0
        this.offset = 0
        this.size = 10
        this.list = []
        this.$refs.InfiniteLoading.stateChanger.reset();

    },
    htmlParser : function (text) {
        return parser.parseFromString(text, "text/html").body.innerText;
    },
    chatbot: function(){
        this.$api.chatbot
        .getChatbotToken()
        .then((token) => {
          this.token = token;
          if(this.token != null){
              // this.$utils.nativeIf.outbound.outlink("https://kyowon-chatbot.ax.dalpha.so/#token="+this.token); //달파 토큰 전송
              window.location.href =  `https://kyowon-chatbot.ax.dalpha.so/#token=${encodeURIComponent(token)}&inpath=WAPLE`;
          }else {
              console.log("else token");
          }
        })
        .catch(function (error) {
          alert(error.rtMsg);
        });
    },
  }
};
</script>
